import React, { useState, useEffect } from 'react';
import { 
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
  Paper, CircularProgress, Box 
} from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';

// 실제 api 파일 구조에 맞게 getActionForecastList 함수 로드
import { getActionForecastList } from '../../lib/api/salesAction'; 

function SalesActionStatTable() {
  const dispatch = useDispatch();
  
  // 🚀 이제 events 배열 전체를 그대로 화면에 나열합니다.
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  // 1. 찬스 모듈 리덕스 상태 조회
  const { chance } = useSelector(({ chanceModule }) => ({
    chance: chanceModule.chance?.chance, 
  }));


  // 2. prjUuid 변동에 따른 최초 및 자동 API 호출 로직
  useEffect(() => {
    const fetchActivityData = async () => {
      if (!chance?.prjUuid) return;

      setLoading(true);
      try {
        const response = await getActionForecastList(chance.prjUuid);

        // 🚀 앞서 확인한 백엔드 컨트롤러의 { list: [...] } 구조에 맞춰서 안전하게 추출
        const resultList = response?.data?.list;
        
        setEvents(Array.isArray(resultList) ? resultList : []);
      } catch (error) {
        console.error("활동 내역을 불러오는데 실패했습니다.", error);
        setEvents([]);
      } finally {
        setLoading(false);
      }
    };

    fetchActivityData();
  }, [chance?.prjUuid]); // prjUuid가 변경될 때마다 실행

  return (
    <Paper 
      elevation={0} 
      sx={{ 
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)', 
        borderRadius: '12px', 
        border: '1px solid rgba(0, 0, 0, 0.03)', 
        overflow: 'hidden', 
        backgroundColor: '#ffffff', 
        display: 'flex', 
        flexDirection: 'column', 
        mt: -0.5 
      }}
    >
      {/* 🚀 데이터가 길어질 경우 내부에서 스크롤되도록 고정 높이 유지 */}
      <TableContainer sx={{ height: 290, overflowY: 'auto', position: 'relative' }}>
        <Table stickyHeader sx={{ minWidth: 600 }} size="small" aria-label="sales action stat detailed table">
          <TableHead>
            <TableRow>
              <TableCell align="center" sx={{ fontWeight: '600', color: '#4B5563', py: 1, backgroundColor: '#F9FAFB', width: '25%', fontSize: '13px' }}>일시</TableCell>
              <TableCell align="left" sx={{ fontWeight: '600', color: '#4B5563', py: 1, pl: 3, backgroundColor: '#F9FAFB', width: '20%', fontSize: '13px' }}>업무구분</TableCell>
              <TableCell align="left" sx={{ fontWeight: '600', color: '#4B5563', py: 1, pl: 2, backgroundColor: '#F9FAFB', width: '25%', fontSize: '13px' }}>제목</TableCell>
              <TableCell align="left" sx={{ fontWeight: '600', color: '#4B5563', py: 1, pl: 2, backgroundColor: '#F9FAFB', width: '30%', fontSize: '13px' }}>활동내역</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow style={{ height: 240 }}>
                <TableCell colSpan={4} align="center">
                  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
                    <CircularProgress size={30} sx={{ color: '#4B5563' }} />
                  </Box>
                </TableCell>
              </TableRow>
            ) : events.length > 0 ? (
              // 🚀 pagedEvents 대신 서버에서 받아온 데이터(events) 전체를 맵핑합니다.
              events.map((row, index) => (
                <TableRow key={row.actionId || row.actionCode || index} hover sx={{ height: 34 }}>
                  <TableCell align="center" sx={{ color: '#374151', py: 0.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '13px' }}>
                    {row.startDatetime && row.endDatetime ? `${row.startDatetime.substring(0, 16)} ~ ${row.endDatetime.substring(11, 16)}` : row.totalTime || '-'}
                  </TableCell>
                  <TableCell align="left" sx={{ pl: 3, fontWeight: '500', color: '#374151', py: 0.5, fontSize: '13px', wordBreak: 'break-all' }}>
                    {row.actionName || '-'}
                  </TableCell>
                  <TableCell align="left" sx={{ pl: 2, color: '#374151', py: 0.5, fontWeight: '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '13px' }}>
                    {row.title || '-'}
                  </TableCell>
                  <TableCell align="left" sx={{ pl: 2, color: '#374151', py: 0.5, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: '13px' }}>
                    {row.actionContent || '-'}
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow style={{ height: 240 }}>
                <TableCell colSpan={4} align="center" sx={{ color: 'text.secondary', fontSize: '13px' }}>
                  등록된 영업 활동 이력이 없습니다.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}

export default SalesActionStatTable;
